var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8C10 5.87827 10.8429 3.84344 12.3431 2.34315C13.8434 0.842854 15.8783 0 18 0C20.1217 0 22.1566 0.842854 23.6569 2.34315C25.1571 3.84344 26 5.87827 26 8C26 10.1217 25.1571 12.1566 23.6569 13.6569C22.1566 15.1571 20.1217 16 18 16C15.8783 16 13.8434 15.1571 12.3431 13.6569C10.8429 12.1566 10 10.1217 10 8ZM10 20C7.34784 20 4.8043 21.0536 2.92893 22.9289C1.05357 24.8043 0 27.3478 0 30C0 31.5913 0.632141 33.1174 1.75736 34.2426C2.88258 35.3679 4.4087 36 6 36H30C31.5913 36 33.1174 35.3679 34.2426 34.2426C35.3679 33.1174 36 31.5913 36 30C36 27.3478 34.9464 24.8043 33.0711 22.9289C31.1957 21.0536 28.6522 20 26 20H10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.165b05aa61c5b301f74b2e5462843c4e.svg";
export { ForwardRef as ReactComponent };